module.exports = __webpack_public_path__ + "img/14.b355fed3.jpg";